// extracted by mini-css-extract-plugin
export default {"modal":"BetaWelcome_modal__mNALR","pictogram":"BetaWelcome_pictogram__+aOM1"};